import { IAppState } from '../../redux';

export function selectIsNewOffer(state: IAppState): boolean {
  const {
    offer: { id },
  } = state;

  return !id;
}
